<script>
  import { createEventDispatcher } from 'svelte';
  const dispatch = createEventDispatcher();
  import { Button, TextField, Card } from "smelte";
  export let photoFile;
  export let photoId;
  let toId;

  function removeImage() {
    dispatch('removeImage', {
      id: photoId
    });
  };

  function moveUp() {
    dispatch('moveUp', {
      id: photoId
    });
  };

  function moveDown() {
    dispatch('moveDown', {
      id: photoId
    });
  };

  function moveTo() {
    if (toId) {
      dispatch('moveTo', {
        id: photoId,
        toId: toId
      });
      toId = "";
    }
  };

</script>
  <Card.Card
    hover=false
    elevation="2"
    classes="rounded inline-flex flex-col overflow-hidden m-2"
  >
    <div slot="title">
      <Card.Title
        title="Foto #{photoFile.photonumber} ({photoFile.filename})"
        subheader="Grootte: {Math.round(photoFile.size/1024)} KB"
      />
    </div>
    <div slot="media">
      <img 
        class="w-full"
        src={photoFile.image}
        alt="Image"
      />
    </div>
    <div slot="text" class="p-5 pb-0 pt-3 text-gray-700 body-2">
      <TextField bind:value={photoFile.description} label="Beschrijving (optioneel)" size=50 spellcheck="true" maxlength="100" name="beschrijving" persistentHint color="blue" class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md" />
    </div>
    <div slot="actions">
      <div class="p-2">
        {#if photoId > 0}
          <Button on:click={moveUp}>&lt;&lt;</Button>
        {:else}
          <Button disabled>&lt;&lt;</Button>
        {/if}
        <input class="m-2 sm:text-sm border-gray-300 rounded-md" type="text" bind:value={toId} size="2" maxlength="2" /><Button on:click={moveTo}>Verplaats</Button>
        {#if photoFile.lastPhoto}
          <Button disabled>&gt;&gt;</Button>
        {:else}
          <Button on:click={moveDown}>&gt;&gt;</Button>
        {/if}
        <Button text on:click={removeImage}>Verwijder</Button>
      </div>
    </div>
  </Card.Card>
<style>
  card {
    margin-bottom: 20px;
  }
  img {
    max-width: 500px;
    max-height: 500px;
  }
</style>
